// import {documentTool,fontInfo,tableInfo } from './const'
export default {
    state: {
        cellWidth: 0, // number
        cellHeight: 0, // number
        alignIndexH: 0, // number
        alignIndexV: 0, // number
        rowNum: 1, // number
        colNum: 1, // number
        tableData: [["", "", "", "", "", ""]], // array[[string]]
        tableFill: [false, false, false], // tableFill控制器
        tableFillColor: ["#ffffff", "#ffffff", "#ffffff"], // tableFill颜色
        createTableFill: [false, false, false], // createtableFill控制器
        createTableFillColor: ["#ffffff", "#ffffff", "#ffffff"], // createtableFill颜色
        createTableDefault: ["#ffffff", "#ffffff", "#ffffff"], // createtableFill默认颜色
        canMerge: false, // 能否合并
        isSelect: false, // 是否有选中的单元格
        canDistribute: false,
        expandList: ["style", "row", "merge"], // 是否能平均单元格
        margins: [],
        borders: [],
        tableTraits: [],
        quickIndex: -1,
    },
    mutations: {
        setTableState(state, obj) {
            if (obj.dataType == "arr") state[obj.type].splice(obj.data.index, 1, obj.data.data);
            else state[obj.type] = obj.data;
        },
        initTableSet(state, object) {
            object.hasOwnProperty("cellWidth") && (state.cellWidth = object.cellWidth);
            object.hasOwnProperty("cellHeight") && (state.cellHeight = object.cellHeight);
            object.hasOwnProperty("alignIndexH") && (state.alignIndexH = object.alignIndexH);
            object.hasOwnProperty("alignIndexV") && (state.alignIndexV = object.alignIndexV);
            object.hasOwnProperty("rowNum") && (state.rowNum = object.rowNum);
            object.hasOwnProperty("colNum") && (state.colNum = object.colNum);
            object.hasOwnProperty("tableData") && (state.tableData = object.tableData);
            object.hasOwnProperty("isSetClrButtons") && (state.tableFill = JSON.parse(JSON.stringify(object.isSetClrButtons)));
            object.hasOwnProperty("buttonsSelectClrs") && (state.tableFillColor = JSON.parse(JSON.stringify(object.buttonsSelectClrs)));
            object.hasOwnProperty("isCanbeMerged") && (state.canMerge = object.isCanbeMerged);
            object.hasOwnProperty("isSelect") && (state.isSelect = object.isSelect);
            object.hasOwnProperty("canDistribute") && (state.canDistribute = object.canDistribute);
            object.hasOwnProperty("margins") && (state.margins = object.margins.slice());
            object.hasOwnProperty("borders") && (state.borders = object.borders.slice());
            object.hasOwnProperty("tableTraits") && (state.tableTraits = object.tableTraits.slice());
            object.hasOwnProperty("quickIndex") && (state.quickIndex = object.quickIndex);
        },
        setTableFill(state, obj) {
            switch (obj.type) {
                case "top": {
                    if (obj.target == "create") state.createTableFill.splice(0, 1, !state.createTableFill[0]);
                    else state.tableFill.splice(0, 1, !state.tableFill[0]);
                    break;
                }
                case "row": {
                    if (obj.target == "create") state.createTableFill.splice(1, 1, !state.createTableFill[1]);
                    else state.tableFill.splice(1, 1, !state.tableFill[1]);
                    break;
                }
                case "column": {
                    if (obj.target == "create") state.createTableFill.splice(2, 1, !state.createTableFill[2]);
                    else state.tableFill.splice(2, 1, !state.tableFill[2]);
                    break;
                }
                case "reset": {
                    if (obj.target == "create") state.createTableFill = [false, true, false];
                    else state.tableFill = [false, false, false];
                    break;
                }
            }
        },
        setTableFillColor(state, obj) {
            switch (obj.type) {
                case "top": {
                    if (obj.target == "create") state.createTableFillColor.splice(0, 1, obj.data);
                    else state.tableFillColor.splice(0, 1, obj.data);
                    break;
                }
                case "row1": {
                    if (obj.target == "create") state.createTableFillColor.splice(1, 1, obj.data);
                    else state.tableFillColor.splice(1, 1, obj.data);
                    break;
                }
                case "row2": {
                    if (obj.target == "create") state.createTableFillColor.splice(2, 1, obj.data);
                    else state.tableFillColor.splice(2, 1, obj.data);
                    break;
                }
                case "reset": {
                    if (obj.target == "create") state.createTableFillColor = state.createTableDefault.slice(0);
                    else state.tableFillColor = ["#ffffff", "#ffffff", "#ffffff"];
                    break;
                }
            }
        },
    },
};
